import React from 'react';
import { appTranslate } from '../../../../../../../../../shared/utils/i18n';
import { toggleQueryParamNavigation } from '../../../../../../../service/clientNavigation';
import { SIMILAR_TIMEZONE_FILTER_ID, SIMILAR_TIMEZONE_QUERY_PARAM } from '../../../../../../../utils/constants';
import { getStandardUtcOffsetInMinutes } from '../../../../../../../utils/timezoneFilter';
import { PillButton } from '../../../../../pill_button';

interface SimilarTimezoneToggleProps {
    active: boolean;
}

export const SimilarTimezoneToggle = ({ active }: SimilarTimezoneToggleProps) => {
    const onClick = () => {
        const utcOffsetInMinutes = getStandardUtcOffsetInMinutes();

        toggleQueryParamNavigation(
            SIMILAR_TIMEZONE_QUERY_PARAM,
            active,
            String(utcOffsetInMinutes),
            SIMILAR_TIMEZONE_FILTER_ID
        );
    };

    return (
        <PillButton isActive={active} onClick={onClick}>
            {appTranslate('search_perseus.filters.global.similar_timezone.toggle_title')}
        </PillButton>
    );
};
